export default "__VITE_ASSET__B0T9i$nn__"